/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { Box, Accordion, AccordionSummary, AccordionDetails, Theme, Link } from '@mui/material'
import { makeStyles } from '@mui/styles'

const Icon: React.FC<{ className: any; img: any }> = ({ className, img = [] }): JSX.Element => {
  return <img src={img.dropdown} alt="" className={className.icon} />
}

export const SamplesCheckList: React.FC<{ userData: any; className: any; img: any }> = ({
  userData = [],
  className,
  img = [],
}): JSX.Element => {
  const classes = useStyles()

  const [samplesCheckList, setSamplesCheckList] = useState<boolean>(false)

  const handleChangeExSamplesCheckList = (show: boolean) => {
    setSamplesCheckList(show)
  }

  return (
    <Box className={classes.samplesCheckList}>
      <Accordion
        id="samplesCheckList"
        expanded={samplesCheckList}
        onChange={() => handleChangeExSamplesCheckList(!samplesCheckList)}
        square={false}
      >
        <AccordionSummary expandIcon={<Icon className={className} img={img} />}>Чек-листы (pdf)</AccordionSummary>
        <AccordionDetails>
          <Box className={className.contentAccordionDetails}>
            <Box mt={1} mb={1}>
              <Link href="/backend/files/avto.pdf" target="_blank" className={classes.link}>
                Чек-лист АВТО
              </Link>
            </Box>
            <Box mt={1} mb={1}>
              <Link href="/backend/files/kuhnya.pdf" target="_blank" className={classes.link}>
                Чек-лист КУХНЯ
              </Link>
            </Box>
            <Box mt={1} mb={1}>
              <Link href="/backend/files/obsluzhivanie.pdf" target="_blank" className={classes.link}>
                Чек-лист ОБСЛУЖИВАНИЕ
              </Link>
            </Box>
            <Box mt={1} mb={1}>
              <Link href="/backend/files/cyplenok.pdf" target="_blank" className={classes.link}>
                Чек-лист ЦЫПЛЁНОК
              </Link>
            </Box>
            {/* <Box mt={1} mb={1}> */}
            {/*  <Link href="/backend/files/test_fusion.pdf" target="_blank" className={classes.link}> */}
            {/*    Тест Fusion */}
            {/*  </Link> */}
            {/* </Box> */}
            {/* <Box mt={1} mb={2}> */}
            {/*  <Link href="/backend/files/test_avto.pdf" target="_blank" className={classes.link}> */}
            {/*    Тест Авто */}
            {/*  </Link> */}
            {/* </Box> */}
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}

const useStyles = makeStyles(({ spacing, font, breakpoints: { down }, palette }: Theme) => ({
  samplesCheckList: {},
  link: {
    fontSize: 18,
    fontWeight: 500,
    transition: '0.2s',
    [down('md')]: {
      fontSize: 16,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  icon: {},
}))
